export default {
  actionItems(state) {
    return state.actionItems;
  },
  mentions(state) {
    return state.mentions;
  },
};
